import PropTypes from 'prop-types';

export const quotePropType = PropTypes.shape({
  id: PropTypes.number,
  status: PropTypes.string,
  expiryDt: PropTypes.string,
  name: PropTypes.string,
  href: PropTypes.string,
  poJobName: PropTypes.string,
  subTotal: PropTypes.number,
});

export const quotesPropType = PropTypes.arrayOf(quotePropType);